import { createFileRoute } from "@tanstack/react-router";
import FundraisingContacts from "@/components/Fundraising/Contacts";
import { PageHeader } from "@/components/PageHeader";

function RouteComponent() {
  return (
    <div className="min-w-0 space-y-4">
      <PageHeader
        title="Contacts"
        subtitle="Manage investor contacts for Allocations fundraising."
      />
      <FundraisingContacts />
    </div>
  );
}

export const Route = createFileRoute("/_authenticated/fundraising/contacts/")({
  component: RouteComponent,
  staticData: { page: "fundraising" },
});
